module.exports = __webpack_public_path__ + "img/sh001-002.40ebb6fa.jpg";